import { render, staticRenderFns } from "./SlidesPreview.vue?vue&type=template&id=f0ec13c0&scoped=true"
import script from "./SlidesPreview.vue?vue&type=script&lang=js"
export * from "./SlidesPreview.vue?vue&type=script&lang=js"
import style0 from "./SlidesPreview.vue?vue&type=style&index=0&id=f0ec13c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ec13c0",
  null
  
)

export default component.exports